import React from "react";

import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

const SidebarDropdown = ({ id, label, options, defaultValue, disabled, onChange, sx }) => {
	defaultValue = defaultValue ? defaultValue : options[0].value
	const [selectedValue, setSelectedValue] = React.useState(defaultValue);

	const findOption = (v) => options.find((opt) => opt.value === v)

	const renderOption = (opt) => {
		return (
	    <MenuItem value={opt.value} key={opt.value}>
	    	{opt.label}
	    </MenuItem>
		)
	}

	return (
		<FormControl variant="outlined" className={id}>
    	<InputLabel id={id}>{label}</InputLabel>
	    <Select
	    	disabled={disabled}
	    	labelId={id}
	    	sx={sx}
	    	value={selectedValue}
	      label={label}
	      onChange={(event) => {
	      	const opt = findOption(event.target.value)
	      	setSelectedValue(opt.value)
	      	onChange(opt.value)
	      }}>
	      {options.map((opt) => renderOption(opt))}
	    </Select>
    </FormControl>
	)
}

export default SidebarDropdown